/** @format */

import React, { useCallback, useState } from "react";
import "./UserWidget.scss";

import { ReactComponent as AccountIcon } from "bootstrap-icons/icons/person.svg";
import { ReactComponent as Cap } from "bootstrap-icons/icons/mortarboard.svg";
import { ReactComponent as ArrowDownLeft } from "bootstrap-icons/icons/arrow-down-left.svg";
import { ReactComponent as X } from "bootstrap-icons/icons/x.svg";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../app/hooks";
import { useGetUserMetaQuery } from "../../app/services/userApi";
import { Link, useLocation } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import AuthFlag from "../auth/AuthFlag";

const UserWidget = () => {
  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false; // useSelector(selectedIsAuthenticated);

  const { t: _ } = useTranslation();
  const location = useLocation();
  const { data } = useGetUserMetaQuery(
    !!isAuthenticated ? undefined : skipToken,
  );
  const [showUserOptions, setShowUserOptions] = useState(false);

  const handleUserOptionsToggle = useCallback(() => {
    if (showUserOptions) {
      setShowUserOptions(false);
    } else {
      setShowUserOptions(true);
    }
  }, [showUserOptions]);

  return (
    <AuthFlag authGroup={["staff"]}>
      <div className="user-widget">
        <>
          <Button
            title="login"
            onClick={handleUserOptionsToggle}
            className="user-options-button"
          >
            {isAuthenticated ? (
              <img
                className="rounded-circle border-1 border bg-primary user-image"
                width="40"
                src={data?.avatar ?? "https://gravatar.com/avatar?d=mp&s=30"}
                alt="Account"
              />
            ) : (
              <span className="text-white">{_("login")}</span>
            )}
          </Button>
          {showUserOptions && (
            <div className="bg-white border-rounded rounded-3 p-3 user-options-wrapper text-end">
              <div className="text-dark user-dropdown">
                {isAuthenticated ? (
                  <>
                    <div className="user-details item gap-3 d-flex align-items-center">
                      <img
                        className="rounded-circle border-1 border bg-primary user-image"
                        style={{
                          width: 40,
                          height: 40,
                        }}
                        src={
                          data?.avatar ??
                          "https://gravatar.com/avatar?d=mp&s=30"
                        }
                        alt={`${data?.name}`}
                      />
                      <p className="m-0">{data?.name}</p>
                      <X
                        className="close ms-auto"
                        viewBox="4 4 8 8"
                        onClick={handleUserOptionsToggle}
                      />
                    </div>
                    <div className="user-options pt-3" role="menu">
                      <Link to="/user/account" title="account-link">
                        <AccountIcon fill="#AEAEAE" title="account-icon" />
                        {_("My Account")}
                      </Link>
                      <Link to="/user/dashboard" title="resources-link">
                        <Cap fill="#AEAEAE" title="resources-icon" />
                        {_("My Resources")}
                      </Link>
                      <Link
                        to="/auth/logout"
                        state={{ from: location }}
                        replace
                        title="logout-link"
                      >
                        <ArrowDownLeft fill="#AEAEAE" title="logout-icon" />
                        {_("Log Out")}
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    <X
                      className="close ms-auto"
                      viewBox="4 4 8 8"
                      onClick={handleUserOptionsToggle}
                    />
                    <div className="user-options" role="menu">
                      <Link
                        to="/auth/hwblogin"
                        state={{ from: location }}
                        replace
                        title="hwb-link"
                      >
                        <img
                          src="https://cdn.hwb.gov.wales/hwb-cms/4.34.31/img/hwb-logo.svg"
                          alt="Hwb"
                        />
                        {_("login")} {_("with")} Hwb
                      </Link>

                      <Link
                        to="/auth/bblogin"
                        state={{ from: location }}
                        replace
                      >
                        {_("Login as staff")}
                      </Link>

                      {/* <Link to="auth/login" state={{ from: location }} replace title="bitbucket-link">
                                                <Bitbucket title="bitbucket-icon" />
                                                {_('login')} {_('with')} {_('Bitbucket')}
                                            </Link> */}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </>
      </div>
    </AuthFlag>
  );
};

export default UserWidget;
